import React from "react";
import {StyleSheet, Text, View, ImageBackground, ScrollView, TouchableOpacity, TextInput , Image} from 'react-native';

import {RFValue} from "react-native-responsive-fontsize";






const Mission = ({navigation})=>{

    return (
        <View style={{flex : 1}}>
            {/*<ImageBackground req source={require('./../../assets/bg.jpg')} resizeMode="cover" style={{flex : 1}}>*/}


            {/*    <ScrollView >*/}
            {/*        <TouchableOpacity style={styles.box}>*/}
            {/*            <View style={{flexDirection : 'row',justifyContent : 'space-between',alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 75,*/}
            {/*                        height :75,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 10,*/}
            {/*                    }}*/}

            {/*                     source={require('./../../assets/facebook.jpg')}/>*/}
            {/*                <Text style={styles.headertext}>*/}
            {/*                    Share  Face book*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View>*/}
            {/*                <Text style={styles.subtext}>*/}
            {/*                    The Share button lets people add a personalized message to links before sharing on their timeline, in groups, or to their friends via a Facebook Message.*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View style={styles.p}>*/}
            {/*                <View style={styles.progress}></View>*/}
            {/*            </View>*/}
            {/*            <View style={{flexDirection : 'row', alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 50,*/}
            {/*                        height :50,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 15,*/}
            {/*                    }}*/}
            {/*                    source={require('./../../assets/money.jpg')}/>*/}
            {/*                <Text style={styles.rewardtext}>*/}
            {/*                    100 USdt Reward*/}
            {/*                </Text>*/}

            {/*                <TouchableOpacity style={{alignItems : 'flex-end' , flex : 1}}>*/}
            {/*                    <View style={styles.btn}>*/}
            {/*                        <Text  style={styles.btntext}>Confirm</Text>*/}
            {/*                    </View>*/}
            {/*                </TouchableOpacity>*/}
            {/*            </View>*/}

            {/*        </TouchableOpacity>*/}

            {/*        <TouchableOpacity style={styles.box}>*/}
            {/*            <View style={{flexDirection : 'row',justifyContent : 'space-between',alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 75,*/}
            {/*                        height :75,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 10,*/}
            {/*                    }}*/}

            {/*                    source={require('./../../assets/twitter.jpg')}*/}
            {/*                    />*/}
            {/*                <Text style={styles.headertext}>*/}
            {/*                    share twitter*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View>*/}
            {/*                <Text style={styles.subtext}>*/}
            {/*                    Click on it and select it. Then, right-click and choose Copy from the menu. Your Twitter profile link will be copied to your computer's clipboard.*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View style={styles.p}>*/}
            {/*                <View style={styles.progress}></View>*/}
            {/*            </View>*/}
            {/*            <View style={{flexDirection : 'row', alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 50,*/}
            {/*                        height :50,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 15,*/}
            {/*                    }}*/}
            {/*                    source={require('./../../assets/coin.jpg')}*/}

            {/*                />*/}

            {/*                <Text style={styles.rewardtext}>*/}
            {/*                    100 USdt Reward*/}
            {/*                </Text>*/}

            {/*                <TouchableOpacity style={{alignItems : 'flex-end' , flex : 1}}>*/}
            {/*                    <View style={styles.btn}>*/}
            {/*                        <Text  style={styles.btntext}>Confirm</Text>*/}
            {/*                    </View>*/}
            {/*                </TouchableOpacity>*/}
            {/*            </View>*/}

            {/*        </TouchableOpacity>*/}
            {/*        <TouchableOpacity style={styles.box}>*/}
            {/*            <View style={{flexDirection : 'row',justifyContent : 'space-between',alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 75,*/}
            {/*                        height :75,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 10,*/}
            {/*                    }}*/}

            {/*                    source={require('./../../assets/twitter.jpg')}*/}
            {/*                />*/}
            {/*                <Text style={styles.headertext}>*/}
            {/*                    share twitter*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View>*/}
            {/*                <Text style={styles.subtext}>*/}
            {/*                    Click on it and select it. Then, right-click and choose Copy from the menu. Your Twitter profile link will be copied to your computer's clipboard.*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View style={styles.p}>*/}
            {/*                <View style={styles.progress}></View>*/}
            {/*            </View>*/}
            {/*            <View style={{flexDirection : 'row', alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 50,*/}
            {/*                        height :50,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 15,*/}
            {/*                    }}*/}
            {/*                    source={require('./../../assets/coin.jpg')}*/}

            {/*                />*/}

            {/*                <Text style={styles.rewardtext}>*/}
            {/*                    100 USdt Reward*/}
            {/*                </Text>*/}

            {/*                <TouchableOpacity style={{alignItems : 'flex-end' , flex : 1}}>*/}
            {/*                    <View style={styles.btn}>*/}
            {/*                        <Text  style={styles.btntext}>Confirm</Text>*/}
            {/*                    </View>*/}
            {/*                </TouchableOpacity>*/}
            {/*            </View>*/}

            {/*        </TouchableOpacity>*/}
            {/*        <TouchableOpacity style={styles.box}>*/}
            {/*            <View style={{flexDirection : 'row',justifyContent : 'space-between',alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 75,*/}
            {/*                        height :75,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 10,*/}
            {/*                    }}*/}

            {/*                    source={require('./../../assets/facebook.jpg')}/>*/}
            {/*                <Text style={styles.headertext}>*/}
            {/*                    Share  Face book*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View>*/}
            {/*                <Text style={styles.subtext}>*/}
            {/*                    The Share button lets people add a personalized message to links before sharing on their timeline, in groups, or to their friends via a Facebook Message.*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View style={styles.p}>*/}
            {/*                <View style={styles.progress}></View>*/}
            {/*            </View>*/}
            {/*            <View style={{flexDirection : 'row', alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 50,*/}
            {/*                        height :50,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 15,*/}
            {/*                    }}*/}
            {/*                    source={require('./../../assets/money.jpg')}/>*/}
            {/*                <Text style={styles.rewardtext}>*/}
            {/*                    100 USdt Reward*/}
            {/*                </Text>*/}

            {/*                <TouchableOpacity style={{alignItems : 'flex-end' , flex : 1}}>*/}
            {/*                    <View style={styles.btn}>*/}
            {/*                        <Text  style={styles.btntext}>Confirm</Text>*/}
            {/*                    </View>*/}
            {/*                </TouchableOpacity>*/}
            {/*            </View>*/}

            {/*        </TouchableOpacity>*/}
            {/*        <TouchableOpacity style={styles.box}>*/}
            {/*            <View style={{flexDirection : 'row',justifyContent : 'space-between',alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 75,*/}
            {/*                        height :75,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 10,*/}
            {/*                    }}*/}

            {/*                    source={require('./../../assets/twitter.jpg')}*/}
            {/*                />*/}
            {/*                <Text style={styles.headertext}>*/}
            {/*                    share twitter*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View>*/}
            {/*                <Text style={styles.subtext}>*/}
            {/*                    Click on it and select it. Then, right-click and choose Copy from the menu. Your Twitter profile link will be copied to your computer's clipboard.*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*            <View style={styles.p}>*/}
            {/*                <View style={styles.progress}></View>*/}
            {/*            </View>*/}
            {/*            <View style={{flexDirection : 'row', alignItems : 'center'}}>*/}
            {/*                <Image*/}
            {/*                    resizeMode={'stretch'}*/}
            {/*                    fadeDuration={999}*/}
            {/*                    style={{*/}
            {/*                        width : 50,*/}
            {/*                        height :50,*/}
            {/*                        marginVertical : 10,*/}
            {/*                        borderRadius : 15,*/}
            {/*                    }}*/}
            {/*                    source={require('./../../assets/coin.jpg')}*/}

            {/*                />*/}

            {/*                <Text style={styles.rewardtext}>*/}
            {/*                    100 USdt Reward*/}
            {/*                </Text>*/}

            {/*                <TouchableOpacity style={{alignItems : 'flex-end' , flex : 1}}>*/}
            {/*                    <View style={styles.btn}>*/}
            {/*                        <Text  style={styles.btntext}>Confirm</Text>*/}
            {/*                    </View>*/}
            {/*                </TouchableOpacity>*/}
            {/*            </View>*/}

            {/*        </TouchableOpacity>*/}


            {/*    </ScrollView>*/}





            {/*</ImageBackground>*/}




        </View>
    );
}


const styles = StyleSheet.create({

    progress : {
      width : '85%',
      backgroundColor : '#8e2de2',
        height : RFValue(10),
        marginVertical : RFValue(15),
        borderRadius : RFValue(25),
        borderWidth : 2,
        borderColor : '#FFF',

    },

    rewardtext: {
        color : '#444',
        fontFamily : 'novaria',
        textAlign : "justify",
        fontSize : RFValue(15),
        paddingHorizontal : RFValue(10),
    },
    p : {
      borderTopWidth : 1,
      borderTopColor : '#999',
        marginTop : RFValue(5),

    },

    subtext : {
        color : '#444',
        fontFamily : 'novaria',
        textAlign : "justify",
        fontSize : RFValue(13)
    },
    headertext : {
      flex : 1,
        color : '#111',
        fontFamily : 'novaria',
        textAlign : "center",
        fontSize : RFValue(22)
    },

    box :{
      backgroundColor : 'rgba(255,255,255,0.7)',
        marginHorizontal : RFValue(15),
        marginTop : RFValue(8),
        borderRadius : RFValue(10),
        padding : RFValue(15),

    },

    btn : {

        borderWidth : 1,
        borderColor : '#FFF',
        width : RFValue(90),
        justifyContent : "center",
        alignItems: 'center',
        padding : RFValue(7),
        borderRadius : RFValue(5),
        backgroundColor : '#8e2de2',
        marginHorizontal : RFValue(8),



    },


    btntext : {
        color : '#FFF',
        fontFamily : 'novaria',
        fontSize : RFValue(11),
    },


});


export default Mission;
